var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$statsigState && _vm.$statsigState.loading)?_vm._t("loading",function(){return [_c('BaseLoader',{attrs:{"size":"xl"}})]}):(_vm.$statsigState && _vm.$statsigState.initialized && _vm.isFeatureEnabled)?[_vm._t("new")]:[_vm._t("old")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }